export default __webpack_public_path__ + "static/media/procedure9.cc72e6dc.jpg";